import { render } from "./AgGridBtnRender.vue?vue&type=template&id=5479e17e"
import script from "./AgGridBtnRender.vue?vue&type=script&lang=js"
export * from "./AgGridBtnRender.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__